//export const COINFLIP_ADDRESS = "0x6d9AeE60C87f97BF3Cdce3d59C6c6C2e80F301ca"; // VRF v1 on Kovan
export const COINFLIP_ADDRESS = "0x8D370C19FFAf04B43895855b96A89BDc92B71FD9"; // VRF v2 on Rinkeby
export const SUPPORTED_CHAINS = [137];
export const WAITFOR_CONFIRMATIONS = 2;
